import { takeLatest, all, call, put, select } from "redux-saga/effects";
import { updateAdmin, allAdmins as allAdminsAction, resetAdmins} from "./actions";
import types from "./types";
import {api} from "../../../services/api";






export function* allAdmins() {


  
  const { form , reservations, auth } = yield select((state) => state.admin);
  try {
    yield put(updateAdmin({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/reservations/${reservations.start_date?reservations.start_date : ":?"}/${reservations.end_date?reservations.end_date : ":?"}`, {
      headers: {
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    });
    yield put(updateAdmin({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }


    
    if(res.length >= 1){
    yield put(updateAdmin({ reservations:[{...reservations, ...res }]}));}
   
  } catch (error) {
    yield put(updateAdmin({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}
export function* allAdminsVANS() {


  
  const { form ,  auth ,extraTimeVans } = yield select((state) => state.admin);
  try {
    yield put(updateAdmin({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/extratime`, {
      headers: {
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    });
    yield put(updateAdmin({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }


    
    if(res.length >= 1){
    yield put(updateAdmin({ extraTimeVans:[...res ]}));}
   
  } catch (error) {
    yield put(updateAdmin({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* filterAdmin() {
  const { form, cliente } = yield select((state) => state.cliente);
  try {
    yield put(updateAdmin({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.post, `/clientes/filter`, {
      filters: { email: cliente.email, status: "A" },
    });
    yield put(updateAdmin({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    if (res.clientes.length > 0) {
      yield put(
        updateAdmin({
          cliente: res.clientes[0],
          form: { ...form, filtering: false, disable: false },
        })
      );
    } else {
      yield put(updateAdmin({ form: { ...form, disable: false } }));
    }
  } catch (error) {
    yield put(updateAdmin({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}




export function* unlinkAdmin() {
  const { form, cliente, components } = yield select((state) => state.cliente);
  try {
    yield put(updateAdmin({ form: { ...form, saving: true } }));
    const { data: res } = yield call(api.delete, `/clientes/vinculo/${cliente.vinculoId}`);
    yield put(updateAdmin({ form: { ...form, saving: false  } ,
    }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(allAdminsAction())
    yield put(updateAdmin({ components: { ...components, drawer: false , confirmDelete: false} }))
    yield put(resetAdmins())
  
  } catch (error) {
    yield put(updateAdmin({ form: { ...form, saving: false } }));
    alert(error.message);
  }
}




export function* loginSessionAdminIn() {

  const { form, loginAdmin,administrador } = yield select((state) => state.admin);


  try {
   
    yield put(updateAdmin({ form: { ...form, saving: true } }));
    const  {data: res}  = yield call(api.post,`/login`, {email:loginAdmin.email,  password: loginAdmin.password});

    yield put(updateAdmin({ form: { ...form, saving: false } }));
    yield put(updateAdmin({ auth: { id: res.token } }));
    yield put(updateAdmin({ cliente: {...administrador,  
      id: res.id,
      name: res.name,
      email:res.email,        
      active: true,} }));

 
    if (res.error) {     
      yield put(updateAdmin({ form: { ...form, fail: true } }));
      yield put(updateAdmin({ form: { ...form, errorTag: "Email ou senha errada" } }));
      alert(res.message);
      return false;
    }
 
    if (res.clientes.length > 0) {
      yield put(
        updateAdmin({
       
          cliente: res.clientes[0],
          form: { ...form, filtering: false, disable: false },
        })
      );
      yield put(updateAdmin({ form: { ...form, fail: false } }));
      yield put(updateAdmin({ form: { ...form, errorTag: "login" } }));
    } else {
      yield put(updateAdmin({ form: { ...form, disable: false } }));
    }
  } catch (error) {
 
  alert(error.response + error.data.response);
  }
}


export function* sessionLogOut (){
  const { form, loginCliente, auth,cliente } = yield select((state) => state.admin);

  try {
      
     
    yield put(updateAdmin({ auth: { id: "" } }));
    sessionStorage.setItem("token",``)
   
    sessionStorage.setItem("id","")
    sessionStorage.setItem("name","")
    sessionStorage.setItem("email","")
    sessionStorage.setItem("active",false)
    yield put(updateAdmin({ cliente: {...cliente,  
      id: "",
      name: "",
      email:"",        
      active: false} }));       
 
   
     

    }
   catch (error) {
    yield put(updateAdmin({ form: { ...form, filtering: false } }));
   yield put(updateAdmin({ form: { ...form, fail: true } }));
   
  yield put(updateAdmin({ form: { ...form, errorTag: `${error}` } }));

  alert(error.response.data.message);
  }
}






export function*  CheckOutCar(){
  const { form , reservations, auth } = yield select((state) => state.admin);
  try {
    yield put(updateAdmin({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/reservations/${reservations.start_date?reservations.start_date : ":?"}/${reservations.end_date?reservations.end_date : ":?"}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    });
    yield put(updateAdmin({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }


    
    if(res.length >= 1){
    yield put(updateAdmin({ reservations:[{...reservations, ...res }]}));}
   
  } catch (error) {
    yield put(updateAdmin({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}


export default all([
  takeLatest(types.ALL_ADMINS_RESERVA_CARRROS, allAdmins),
  takeLatest(types.ALL_ADMINS_VANS, allAdminsVANS),
  takeLatest(types.FILTER_ADMINS, filterAdmin),
  takeLatest(types.LOGIN_SESSION_OUT, sessionLogOut),
  takeLatest(types.UNLINK_ADMINS, unlinkAdmin),
  takeLatest(types.LOGIN_ADMIN_SESSION_IN, loginSessionAdminIn),
  takeLatest(types.CHECK_OUT, CheckOutCar)

]);
